import styled from "@emotion/styled";

interface ShoppingCartFlyoutScrollableWrapperProps {
	isReplacementsPage?: boolean;
	isDetailsPage?: boolean;
}

export const ShoppingCartFlyoutScrollableWrapper = styled.div<ShoppingCartFlyoutScrollableWrapperProps>(
	({ isReplacementsPage, isDetailsPage, theme }) => {
		let pxForCalculation;
		let pxForCalculationMobile;
		if (isReplacementsPage) {
			pxForCalculationMobile = 298;
			pxForCalculation = 253;
		} else {
			pxForCalculationMobile = 181;
			pxForCalculation = 136;
		}

		if (isDetailsPage) {
			pxForCalculationMobile = 165;
			pxForCalculation = 120;
		}

		return {
			overflowY: "scroll",
			height: `calc(100vh - ${pxForCalculation}px)`,
			[theme.breakpoints.down("lg")]: {
				height: `calc(100vh - ${pxForCalculationMobile}px)`
			}
		};
	}
);
